/**
 * @file Discover Album Folder Purchase view.
 */

import React from 'react';

import AlbumFolderPurchasePrePurchaseContainer from '../../containers/purchase/album-folder-purchase/AlbumFolderPurchasePrePurchaseContainer';

const AlbumFolderPurchasePrePurchaseView = props => (
  <AlbumFolderPurchasePrePurchaseContainer {...props} />
);

export default AlbumFolderPurchasePrePurchaseView;
